module.exports = __webpack_public_path__ + "img/1F1F5-1F1F9.06300622.svg";